import { MaterialInput, MaterialTextarea } from 'app/components'
import { SendMailAction } from 'app/redux/SendMail/actions'
import * as React from 'react'
import { Button, Col, Form, FormGroup, Row } from 'react-bootstrap'

interface IContactUsState {
  hasSentMessage: boolean,
  name: string,
  email: string,
  message: string
}

class ContactUs extends React.Component<{}, IContactUsState> {

  state = {
    hasSentMessage: false,
    name: '',
    email: '',
    message: '',
  }

  onSubmit(e: React.FormEvent<Form>) {
    e.preventDefault()

    SendMailAction.sendEmail(this.state.name, this.state.email, this.state.message)
      .then((response) => {
        this.setState({ hasSentMessage: true })
        this.state.name = ''
        this.state.email = ''
        this.state.message = ''
        setTimeout(() => {
          this.setState({ hasSentMessage: false })
        }, 5000)
      })
      .catch((error) =>
        // tslint:disable-next-line:no-console
        console.log(error)
      )
  }

  render() {
    return (
      <section className="well">
        <div className="container">
          <Row>
            <Col sm={4} md={5}
              className="margin-bottom-lg" style={{ fontSize: '1.15em' }}>
              <h3 style={{ marginTop: 0 }}>Contact Us</h3>
              <p>
                <span>General Contact</span><br />
                <a href="mailto:info@foundationmark.com">
                  info@foundationmark.com
                </a>
              </p>
              <p>
                <span>Media Contact</span><br />
                <a href="mailto:inquiries@foundationmark.com">
                  inquiries@foundationmark.com
                </a>
              </p>
            </Col>
            <Col sm={7} md={6}>
              <Form onSubmit={(e) => this.onSubmit(e)}>
                <legend>Message Us</legend>
                <FormGroup>
                  <MaterialInput placeholder="Name"
                    required
                    disabled={this.state.hasSentMessage}
                    value={this.state.name}
                    onChange={(name) => this.setState({ name })} />
                </FormGroup>
                <FormGroup>
                  <MaterialInput placeholder="Email" type="email"
                    required
                    disabled={this.state.hasSentMessage}
                    value={this.state.email}
                    onChange={(email) => this.setState({ email })} />
                </FormGroup>
                <FormGroup>
                  <MaterialTextarea placeholder="Message" rows={3}
                    required
                    disabled={this.state.hasSentMessage}
                    value={this.state.message}
                    onChange={(message) => this.setState({ message })} />
                </FormGroup>
                <FormGroup>
                  <Button type="submit" block
                    disabled={this.state.hasSentMessage}
                    bsStyle={this.state.hasSentMessage ? 'success' : 'default'}>
                    {this.state.hasSentMessage ?
                      <section>
                        <span>Message Sent&nbsp;</span>
                        <i className="fa fa-fw fa-thumbs-up" />
                      </section>
                      :
                      <section>Send Message</section>
                    }
                  </Button>
                </FormGroup>
              </Form>
            </Col>
          </Row>
        </div>
      </section>
    )
  }
}

export {
  ContactUs
}



// WEBPACK FOOTER //
// ./src/app/components/section/ContactUs/index.tsx